import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class DoubleViseur extends ActionCard {
    static typeId = "DOUBLE_VISEUR";
    static cardName = "Double Viseur";
    static colorHex = "#3399FF";
    static countInDeck = ACTION_CARD_COUNTS.DOUBLE_VISEUR;
    static description = "Placez deux cibles sur 2 emplacements adjacents";

    isValidOn(slotIndex, gameState) {
        const currentEmpty = !gameState.lineOfFireSlots[slotIndex].isTargeted;
        const nextEmpty = (slotIndex + 1 <= 5) ? !gameState.lineOfFireSlots[slotIndex + 1].isTargeted : false;

        // The move is allowed if AT LEAST one token can be placed
        return currentEmpty || nextEmpty;
    }

    resolve(slotIndex, gameState) {
        gameState.addTargetsToSlots([slotIndex, slotIndex + 1]);
    }
}
